export const SETTLED = 'SETTLED';
export const SCHEDULED = 'SCHEDULED';
export const getStatus = (status) => {
  if (typeof status !== 'string' || !status.trim()) return '';
  return status.toLowerCase().includes('sale') ? 'Venta' : 'Devolución';
};

export const TYPE_CARD = {
  DEBIT_CARD: 'Tarjeta de débito',
  CREDIT_CARD: 'Tarjeta de crédito',
  FPAY_BALANCE: 'Cuenta Fpay',
  POINT_PAYMENTS: 'Pago con Puntos',
  PREPAY: 'Prepago',
  FCOM: 'Puntos + Soles',
  BANK_ACCOUNT: 'Cuenta bancaria',
  PAYMENT_WITH_YAPE: 'Yape',
};

export const getMethod = (method) => {
  if (['DEBIT', 'DEBITO', 'DÉBITO'].some((type) => method.toUpperCase().indexOf(type) > -1))
    return TYPE_CARD.DEBIT_CARD;

  /** FIXME: revisar efectivamente cuales son los operations de los distintos ambientes */
  switch (method) {
    case 'Saldo FPay':
    case 'Pago con SVA (Saldo wallet)':
    case 'Pago con SVA':
    case 'Cancel Saldo FPay':
    case 'Cancel Pago con SVA':
    case 'Cancel Pago con SVA (Saldo wallet)':
      return TYPE_CARD.FPAY_BALANCE;
    case 'Tarjeta Debit Falabella':
    case 'Cancel PagTarj debt Falabella':
    case 'Cancel PagTarj debito Terceros':
      return TYPE_CARD.DEBIT_CARD;
    case 'Cancel Tarjeta Crédito sin cuotas':
    case 'Reversa partial credito':
    case 'CMR sin cuotas':
    case 'Tarjeta Crédito sin cuotas':
      return TYPE_CARD.CREDIT_CARD;
    case 'Pago con Puntos':
    case 'Cancel Pago con Puntos':
    case 'Pg Con Checkout Points':
    case 'Rev Pg Con Checkout Points':
      return TYPE_CARD.POINT_PAYMENTS;
    case 'Pago Con Tarjeta Prepago':
      return TYPE_CARD.PREPAY;
    case 'Rev Pg Con Tarjeta Prepago':
      return TYPE_CARD.PREPAY;
    case 'Falabella.com Fpay':
      return TYPE_CARD.FCOM;
    case 'Cargo cuenta corriente':
    case 'Canc Cargo cuenta corriente':
      return TYPE_CARD.BANK_ACCOUNT;
    case 'Pago con Yape':
    case 'Canc Pago con Yape':
      return TYPE_CARD.PAYMENT_WITH_YAPE;
    default:
      return TYPE_CARD.CREDIT_CARD;
  }
};

/**
 * used: redux useTransactions
 */
export const TypeMerchant = {
  PHYSICAL: 'physical',
  ECOMMERCE: 'ecommerce',
  FALABELLA: 'falabella',
};

export const CalendarChannels = {
  ...TypeMerchant,
  TOTAL: 'total',
};

export const UnitPerPage = 10;

/**
 * used: helper transactions
 */
export const LimitTransactionsMobile = 500;

export const REPORT_TRANSACTIONS_LIMIT = 60;

export const USER_PISMO = { first_name: 'PISMO', last_name: '' };

export const FORMAT_TYPE_MOVEMENT_AUTHORIZATION = {
  INGRESO: 'Ingreso',
  EGRESO: 'Egreso',
};

export const TYPE_MOVEMENT_AUTHORIZATION = {
  TED_CASH_IN: 'TED CASH IN',
  TED_CASH_IN_ADVANCEMENTS: 'TED CASH IN ADVANCEMENTS',
  TED_CASH_OUT: 'TED CASH OUT',
  CARGO_SALDO: 'CARGO SALDO',
  CARGO_SALDO_REGULARIZADO: 'CARGO REGULARIZACION SALDO',
  INGRESO_DE_SALDO: 'INGRESO DE SALDO',
  EGRESO_DE_SALDO: 'EGRESO DE SALDO',
  PAGO_DE_CUOTA_DE_CREDITO: 'PAGO DE CUOTA DE CRÉDITO',
  CANCELACION_DE_PAGO: 'DEVOL PAGO DE CUOTA DE CRÉDITO',
  CANCEL_EGRESO_DE_SALDO: 'CANCEL EGRESO DE SALDO',
  CANCEL_INGRESO_DE_SALDO: 'CANCEL INGRESO DE SALDO',
  CANCEL_CARGO_SALDO: 'CAN CARGO SALDO',
};

export const FORMAT_SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION = {
  RETIRO: 'Retiro de fondos',
  TRANSFERENCIA: 'Transferencia diferida',
  ORDEN: 'Orden de pago',
};

export const SOFT_DESCRIPTOR_MOVEMENT_AUTHORIZATION = {
  TEF_CASH_OUT: 'TEF CASH OUT',
  TED_CASH_OUT: 'TED CASH OUT',
  TED_CASH_IN: 'TED CASH IN',
  ORDEN_PAGO: 'ORDEN PAGO',
};
